import React, {useEffect} from 'react';

import styles from './styles/result-modal.module.css';

import FileBox from './FileBox';
import Button from '../../common-women/Button';

import {ReactComponent as ReSend} from '../../../assets/docs-women/re-send-red.svg';
import {ReactComponent as Fail} from '../../../assets/docs-women/result-fail.svg';
import {ReactComponent as Success} from '../../../assets/docs-women/result-success.svg'; 

export default function ResultModal({ uploadFileList, uploadResponse, uploadError, handleUpload, handleCloseModal, reReadDocsList }) {
    useEffect(() => {
        let timer;

        if (uploadResponse) {
            timer = setTimeout(() => {
                handleCloseModal();
                reReadDocsList();
            }, 2000);
        }
        
        return () => {
            clearTimeout(timer);
        };
    }, [uploadResponse, handleCloseModal]);

    return (
    <div className={styles.wrapper}>
        <div className={styles.containerTitle}>
            <div className={styles.boxTitle}>
                {uploadResponse && <Success />}
                {uploadError && <Fail />}
                <p>
                    {uploadResponse && '업로드 성공'}
                    {uploadError && '업로드 실패'}
                </p>
            </div>
            {uploadError && 
                <div className={styles.boxBtn}>
                    <Button
                        text='재시도'
                        width='fit-content'
                        height='fit-content'
                        backgroundColor='transparent'
                        fontSize='18px'
                        fontWeight='600'
                        textColor='#ED1C24'
                        onClick={handleUpload}
                    />
                    <ReSend />
                </div>
            }
        </div>
        
        {uploadError && 
            <div className={styles.containerError}>
                <div className={styles.boxList}>
                    {uploadFileList.map((file) => (
                        <FileBox 
                            key={file.id}
                            file={{
                                ...file,
                                error: '오류 : 서버 오류'
                            }} 
                        />
                    ))}
                </div>
                <Button
                    text='확인'
                    width='100px'
                    height='40px'
                    backgroundColor="#ED1C24"
                    borderRadius='50px'
                    fontSize='16px'
                    fontWeight='600'
                    textColor='#FFF'
                    onClick={handleCloseModal}
                    style={{ alignSelf: 'flex-end' }} 
                />
            </div>
        }
    </div>
  );
}